import { ReactComponent as autoStoriesIcon } from '../../../../../icons/auto_stories.svg';
import { ReactComponent as DeleteIcon } from '../../../../../icons/delete.svg';
import React, { useContext, useState } from "react";
import Modal from "../../../../../components/modalWindow/modal";
import ButtonField from '../../../../../components/buttonField/buttonField';
import { classNameBtn, iconPosition } from '../../../../../components/shared/button/types/buttonProps';
import { ButtonFieldProps } from '../../../../../components/buttonField/types/buttonFieldProps';
import { iconStyle, styleFormField, stylizationVerticalAlign } from '../../../../../components/shared/stylization';
import { apiContext } from '../../../../../contexts/apiContext';
import { notifyError, notifySuccess } from '../../../../../components/snackbar/snackbar';
import { AuthorsAddModalProps } from './types/authorsAddModalProps';
import { FormFieldProps } from '../../../../../components/formField/types/formFieldProps';
import FormField from '../../../../../components/formField/formField';
import './authorsAddModal.scss';
import PoFormContext, { AuthorsAttributes, InstitutionsAttributes } from '../../../../../contexts/poFormContext';
import { ReactComponent as addCircleIcon } from '../../../../../icons/add_circle.svg';
import { SelectInputProps } from '../../../../../components/shared/selectInput/types/selectInputProps';
import SelectInput from '../../../../../components/shared/selectInput/selectInput';
import { Option } from "../../../../../components/shared/selectInput/types/selectInputProps";
import { AddAuthorDictProposalProps } from '../../../../../services/dictionariesService/types/dictionariesServiceProps';
import { addAuthorDictProposal } from '../../../../../services/dictionariesService/dictionariesService';
import { configValidation, createConfigValidation } from "../../../../../helpers/validation/validation";
import KrFormContext from '../../../../../contexts/krFormContext';
import { setDictProposition } from '../../../../../database/indexedDbReadWrite';
import AuthContext from '../../../../../contexts/authContext';

const AuthorsAddModal = (props: AuthorsAddModalProps) => {
    const api = useContext(apiContext);
    const { username, onlineMode } = useContext(AuthContext);
    const { local } = useContext(KrFormContext);
    const { localPo } = useContext(PoFormContext);
    const [selectedInstitutions, setSelectedInstitutions] = useState<Option[]>([]);
    const [newInstitutions, setNewInstitutions] = useState<InstitutionsAttributes[]>([]);
    const [newAuthor, setNewAuthor] = useState<AuthorsAttributes>({});
    const [reload, setReload] = useState(false);
    const [checkValidationFlag, setCheckValidationFlag] = useState<boolean>(false);
    const [selectedAcademicTitle, setSelectedAcademicTitle] = useState<Option[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    // Inputs
    const getInputProps = (labelName: string, inputPlaceholder: string, inputId: string, authorInput: boolean, newInstitutionIndex?: number, value?: string, configValidation?: configValidation): FormFieldProps => {
        return {
            labelName: labelName,
            inputPlaceholder: inputPlaceholder,
            type: "text",
            pristine: true,
            value: value,
            className: "empty",
            setValue: (event: any) => authorInput ? onChangeInputNewAuthor(event, inputId) : onChangeInputNewInstitution(event, inputId, newInstitutionIndex!),
            configValidation: configValidation,
            validationError: checkValidationFlag,
            disabled: loading,
            reload: reload
        };
    }

    const onChangeInputNewAuthor = (event: any, id: any) => {
        setNewAuthor((prevData) => ({ ...prevData, [id]: event }));
    }

    const onChangeInputNewInstitution = (event: any, id: any, index: number) => {
        var currentNewInstitutions: InstitutionsAttributes[] = [...newInstitutions];
        currentNewInstitutions[index] = { ...currentNewInstitutions[index], [id]: event }
        setNewInstitutions(currentNewInstitutions);
    }

    // Selects
    const getSelectProps = (label: string, onlySingleTag: boolean, options: Option[], selectedOptions: Option[], onChange: Function,
        configValidation?: configValidation, validationError?: boolean): SelectInputProps => {
        return {
            label: label,
            placeHolder: "Wybierz z listy",
            hasInputTags: true,
            onlySingleTag: onlySingleTag,
            options: options,
            selectedOptions: selectedOptions,
            style: styleFormField,
            className: loading ? "authorsInstitutionSelectWhenLoading" : undefined,
            onChange: (opt: Option[]) => { onChange(opt) },
            disabled: loading,
            configValidation: configValidation,
            validationError: validationError
        }
    }

    const onChangeInstitutions = (opt: Option[]) => {
        if (opt.length > 0) setSelectedInstitutions(opt);
    }

    const onChangeAcademicTitle = (opt: Option[]) => {
        setSelectedAcademicTitle(opt);

        var newValue = opt.length > 0 ? opt[0].value as string : undefined ;
        setNewAuthor((prevData) => ({ ...prevData, tytul: newValue }));
    }

    // Add new institution button  
    const addNewInstitution = () => {
        var newInstitutionArray = [...newInstitutions];
        newInstitutionArray.push({});
        setNewInstitutions(newInstitutionArray);
    }

    const handleNewInstitutionDelete = (index: number) => {
        var currentNewInstitutions = newInstitutions.filter((item: any, i) => {
            return i !== index;
        });
        setNewInstitutions(currentNewInstitutions);
        setReload(!reload);
    }

    const getNewInstitutionForm = (item: any, index: number) => {
        return (
            <>
                <div key={index}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                        <h3>Nowa instytucja {index + 1}</h3>
                        <div className="deleteNewInstitutionIcon" onClick={() => { handleNewInstitutionDelete(index) }}>
                            <DeleteIcon style={iconStyle} />
                            <p>Usuń</p>
                        </div>
                    </div>
                    <FormField {...getInputProps("Nazwa", "Wpisz nazwę Instytucji", "nazwa", false, index, item["nazwa"], createConfigValidation("onlyRequired"))} /> <br />
                    <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                        <FormField {...getInputProps("Ulica", "Wpisz nazwę ulicy", "ulica", false, index, item["ulica"], createConfigValidation("onlyRequired"))} />
                        <FormField {...getInputProps("Numer", "Wpisz numer", "nr", false, index, item["nr"], createConfigValidation("onlyRequired"))} />
                    </div> <br />
                    <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                        <FormField {...getInputProps("Miejscowość", "Wpisz miejscowość", "miejscowosc", false, index, item["miejscowosc"], createConfigValidation("onlyRequired"))} />
                        <FormField {...getInputProps("Kod pocztowy", "Wpisz kod pocztowy", "kod", false, index, item["kod"], createConfigValidation("onlyRequired"))} />
                    </div>
                </div> <br />
            </>
        )
    }

    // Add author proposal button
    const getBtnProps = (title: string, className: string, onClick: React.MouseEventHandler<HTMLButtonElement>, icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>, width?: number): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${classNameBtn.Btn} ${className} body-txt-medium`,
                disabled: loading,
                style: {
                    height: "50px",
                    width: width ? `${width}px` : ''
                }
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start
        };
    }

    const checkInstitutionValidation = (inst: InstitutionsAttributes) => {
        setCheckValidationFlag(true);

        if (inst.nazwa === undefined || inst.nazwa === null) return false;
        if (inst.ulica === undefined || inst.ulica === null) return false;
        if (inst.nr === undefined || inst.nr === null) return false;
        if (inst.miejscowosc === undefined || inst.miejscowosc === null) return false;
        if (inst.kod === undefined || inst.kod === null) return false;
        return true;
    }

    const checkValidation = () => {
        setCheckValidationFlag(true);

        if (newAuthor.imie === undefined || newAuthor.imie === null) return false;
        if (newAuthor.nazwisko === undefined || newAuthor.nazwisko === null) return false;

        if (newInstitutions.length > 0 && !newInstitutions.every(item => checkInstitutionValidation(item))) return false;
        if (newInstitutions.length === 0 && selectedInstitutions.length === 0) return false;
        return true;
    }

    const addAuthorProposal = () => {
        if (checkValidation()) {
            var selectedInstitutionsIds = selectedInstitutions.map(item => {
                return item.value;
            })

            let addAuthorDictProposalProps: AddAuthorDictProposalProps = {
                newAuthor: newAuthor,
                selectedInstitutionsIds: selectedInstitutionsIds,
                newInstitutions: newInstitutions,
                apiBase: api.apiUrl + api.apiVersion
            }

            setLoading(true);
            if ((local || localPo) && !onlineMode) {
                setDictProposition(username, addAuthorDictProposalProps, "author").then((response) => {
                    notifySuccess({ message: "Dodano propozycję autora, propozycja zostanie zsynchronizowana po przejściu na tryb online" });
                    props.cleanSelects();
                    close();
                }).catch(() => {
                    notifyError({ message: "Dodanie propozycji autora zakończone niepowodzeniem" });
                }).finally(() => {
                    setLoading(false);
                });
            } else {
                addAuthorDictProposal(addAuthorDictProposalProps)
                    .then(() => {
                        notifySuccess({ message: "Dodano propozycję autora" });
                        props.cleanSelects();
                        close();
                    })
                    .catch(() => {
                        notifyError({ message: "Dodanie propozycji autora zakończone niepowodzeniem" });
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        }
    }

    const close = () => {
        props.onClose();
        refocus();
    }

    const refocus = () => {
        if (props.refocus) props.refocus();
    }

    return (<Modal
        title={"Dodaj autora"}
        titleIcon={autoStoriesIcon}
        iconClass='titleIcon'
        width={'700px'}
        height={'100vh'}
        onClose={close}
        loading={loading}>
        <div style={{ padding: "0px 100px 0px 100px" }}>
            <FormField {...getInputProps("Imię", "Wpisz imię autora", "imie", true, undefined, newAuthor.imie, createConfigValidation("onlyRequired"))} /> <br />
            <FormField {...getInputProps("Nazwisko", "Wpisz nazwisko autora", "nazwisko", true, undefined, newAuthor.nazwisko, createConfigValidation("onlyRequired"))} /> <br />
            <SelectInput {...getSelectProps(
                "Tytuł",
                true,
                props.academicTitleDict ? props.academicTitleDict : [],
                selectedAcademicTitle,
                onChangeAcademicTitle,
            )} /> <br />
            <FormField {...getInputProps("Uprawnienia", "Wpisz uprawnienia autora", "uprawnienia", true, undefined, newAuthor.uprawnienia)} /> <br />
            <SelectInput {...getSelectProps(
                "Instytucja",
                false,
                props.institutionOptions ? props.institutionOptions : [],
                selectedInstitutions,
                onChangeInstitutions,
                createConfigValidation("onlyRequired"),
                newInstitutions.length > 0 ? undefined : checkValidationFlag
            )} />
            {newInstitutions.map((item, index) => {
                return getNewInstitutionForm(item, index)
            })}
            <br />
            <ButtonField {...getBtnProps("Dodaj nową instytucję", `${classNameBtn.LargeSecondary} addInstitutionBtn`, () => { addNewInstitution() }, addCircleIcon, 224)}></ButtonField>
            <br />
            <div className="modalBtns">
                <ButtonField {...getBtnProps("Anuluj", classNameBtn.LargeSecondary, () => { close() })}></ButtonField>
                <ButtonField {...getBtnProps("Wyślij propozycję autora", `${classNameBtn.Large} addInstitutionBtn`, () => { addAuthorProposal() }, undefined, 224)}></ButtonField>
            </div>
        </div>
    </Modal>);
};

export default AuthorsAddModal;